import injectionCode from '../../../preview/advanced-checkout'

const type = 'advanced'
const path = 'server/nodejs/html/views'
const name = 'checkout.ejs'
const fullPath = `${path}/${name}`

const conditions = [
  {
    option: 'backend',
    type: 'different',
    value: 'java',
  },
  {
    parameter: 'buttons',
    type: 'not_includes',
    value: 'payment-buttons_3ds',
  },
]

export { type, path, name, fullPath, conditions, injectionCode }
